// SSR-safe polyfills for react-snap and other SSR contexts
// This must be imported before any code that uses browser APIs

// Mock Storage (localStorage/sessionStorage)
const mockStorage: Storage = {
  length: 0,
  clear: () => {},
  getItem: () => null,
  key: () => null,
  removeItem: () => {},
  setItem: () => {},
};

// Mock window if needed
if (typeof window === 'undefined') {
  (global as any).window = {
    localStorage: mockStorage,
    sessionStorage: mockStorage,
    document: {},
    navigator: { userAgent: 'ReactSnap' },
    location: { href: '', pathname: '/' },
    addEventListener: () => {},
    removeEventListener: () => {},
    getComputedStyle: () => ({}),
    matchMedia: () => ({ matches: false, addListener: () => {}, removeListener: () => {} }),
  };
}

// Ensure localStorage exists on window
if (typeof window !== 'undefined' && typeof window.localStorage === 'undefined') {
  Object.defineProperty(window, 'localStorage', {
    value: mockStorage,
    writable: true,
  });
}

// Ensure sessionStorage exists on window
if (typeof window !== 'undefined' && typeof window.sessionStorage === 'undefined') {
  Object.defineProperty(window, 'sessionStorage', {
    value: mockStorage,
    writable: true,
  });
}

// Mock document if needed
if (typeof document === 'undefined') {
  (global as any).document = {
    getElementById: () => null,
    querySelector: () => null,
    querySelectorAll: () => [],
    createElement: () => ({}),
    createTextNode: () => ({}),
    body: {},
    head: {},
    addEventListener: () => {},
    removeEventListener: () => {},
  };
}

// Mock navigator if needed
if (typeof navigator === 'undefined') {
  (global as any).navigator = {
    userAgent: 'ReactSnap',
    language: 'en-US',
    languages: ['en-US', 'en'],
  };
}

// Global localStorage polyfill
if (typeof localStorage === 'undefined') {
  (global as any).localStorage = mockStorage;
}

// Global sessionStorage polyfill
if (typeof sessionStorage === 'undefined') {
  (global as any).sessionStorage = mockStorage;
}
